import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
// If you want to import the JS component, using the require.
import { Loading } from '@components/common';
import { changeIsSharingPage } from '@store/common/actions';
import { withParams } from './injectorServer';

interface IProps {
  init: () => void;
  getSharing: (id: string | number) => void;
  isFetching: boolean;
  params: {
    id: string;
  };
  changeIsSharingPageAction: (isSharingPage: boolean) => void;
}

const sharing = () => (Wrapper: React.ClassType<any, any, any>) => {
  class SharingPage extends React.PureComponent<IProps> {
    constructor(props) {
      super(props);
      const { init } = this.props;
      init();
    }

    componentDidMount() {
      const { getSharing, changeIsSharingPageAction, params } = this.props;
      const id = `${get(params, 'id', '')}`;
      getSharing(id);
      changeIsSharingPageAction(true);
    }

    componentWillUnmount() {
      const { changeIsSharingPageAction } = this.props;
      changeIsSharingPageAction(false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const prevId = get(this.props, ['match', 'params', 'id'], '');
      const currId = get(nextProps, ['match', 'params', 'id'], '');
      const { getSharing, changeIsSharingPageAction } = this.props;
      if (prevId !== currId) {
        getSharing(currId);
        changeIsSharingPageAction(true);
      }
    }

    render() {
      const { isFetching, ...rest } = this.props;
      if (isFetching) {
        return <Loading />;
      }
      return <Wrapper isSharing {...rest} />;
    }
  }

  const SharingPageWithParams = withParams(SharingPage)

  return connect(null, { changeIsSharingPageAction: changeIsSharingPage })(SharingPageWithParams);
};

export default sharing;
